// extracted by mini-css-extract-plugin
export var linkText = "_nm-0";